import { render } from "./GuardingSecurityServicePage.vue?vue&type=template&id=5d24d4e4&scoped=true"
import script from "./GuardingSecurityServicePage.vue?vue&type=script&lang=js"
export * from "./GuardingSecurityServicePage.vue?vue&type=script&lang=js"

import "./GuardingSecurityServicePage.vue?vue&type=style&index=0&id=5d24d4e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d24d4e4"]])

export default __exports__